<template>
    <div id="recoverAccount">
    <Background-Image url="assistance-climbing.jpg" color="#3E2723"></Background-Image>
    <Navigation></Navigation>
    <div class="container-fluid m-t-6">
      <div class="row">
        <div class="offset-md-3 col-md-6">
          <div id="UserRecover" class="m-t-4">
            <!--Form with header-->
            <div v-if="!emailSent" class="card padded">
              <div class="card-block">

                <!--Header-->
                <div class="form-header brown darken-2">
                  <h3> {{t('Lost Password')}}?</h3>
                </div>
                <!--Body-->
                <Text-Input :data="form.emailUsername"></Text-Input>
                <div class="text-xs-center">
                  <button v-if="!isUserRecovering" class="btn btn-success btn-lg" id="submitRegisterPromoter" v-on:click="recoverUser()">{{t('Recover Account')}}</button>
                  <button v-if="isUserRecovering" class="btn btn-success btn-lg" v-on:click="recoverUser()"><i class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>

              </div>

              <!--Footer-->
              <div class="modal-footer">
                <div class="options">
                  <p>{{t('Remembered the password?')}} <router-link v-bind:to="loginURL">{{t('Login')}}</router-link></p>
                </div>
              </div>

            </div>

            <div v-if="emailSent" class="card padded">
              <div class="card-block">

                <!--Header-->
                <div class="form-header brown darken-2">
                  <h3> {{t('Help is on the way')}}</h3>
                </div>
                <!--Body-->
                <div class="text-xs-center">
                  <p> {{t('Check your email for instructions on how to recover your account')}}</p>
                </div>

              </div>

              <!--Footer-->
              <div class="modal-footer">
                  <p>
                    <router-link to="/" type="button" class="btn btn-lg btn-success">{{t('Home')}}</router-link>
                  </p>
              </div>

            </div>
            <!--/Form with header-->
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
</template>

<script>
import request from '../../request';
import TextInput from '../Form/V1/TextInput';
import Navigation from '../Navigation/Navigation';
import BackgroundImage from '../BackgroundImage';

export default {
  name: 'PromoterRegistration',
  components: {
    'Text-Input': TextInput,
    'Background-Image': BackgroundImage,
    Navigation,
  },
  data() {
    return {
      emailSent: false,
      isUserRecovering: false,
      form: {
        emailUsername: {
          name: 'emailUsername',
          value: '',
          label: 'Email or username',
          icon: 'fa-user',
          errors: [],
        },
      },
    };
  },
  computed: {
    loginURL() {
      return `/${this.$store.state.language}/login`;
    },
  },
  methods: {
    recoverUser() {
      this.isUserRecovering = true;
      const URL = `${process.env.API_URL}auth/recovery`;
      request.make({
        type: 'POST',
        url: URL,
        data: {
          emailUsername: this.form.emailUsername.value,
          language: this.$store.state.language,
        },
      }, (err, res) => {
        this.isUserRecovering = false;
        if (res.status === 204) { // ok no content
          this.form.emailUsername.errors = [];
          this.emailSent = true;
        } else if (res.status === 404) {
          this.form.emailUsername.errors = ['User does not exist'];
        } else if (res.status === 422) {
          this.form.emailUsername.errors = ['Not a valid username or email'];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#recoverAccount {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// RecoverAccount.vue?65b45337